// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2CqMt","right":"styles_right__MDjWu"};